// class SimpleAccordionItems {
//   constructor(el) {
//     this.el = el;
//     this.elItems = this.el.querySelectorAll(".accordion__item");
//     this.eldesc = this.el.querySelector(".accordion__body-description");

//     for (let item of this.elItems) {
//       new AccordionItem(item, this);
//     }

//     /* window.addEventListener('resize', () => {
//       this.handleResize();
//     }); */
//   }

//   closeOtherItems(currentItem) {
//     this.elItems.forEach((item) => {
//       if (item !== currentItem && item.classList.contains("expanded")) {
//         const button = item.querySelector(".accordion__item-button");
//         const panel = item.querySelector(".accordion__item-panel");

//         button.setAttribute("aria-expanded", false);
//         panel.style.height = "0px";
//         panel.style.opacity = "0";
//         item.classList.remove("expanded");

//         const bodyContent = item.querySelector('.accordion__body-content');
//         if (bodyContent) {
//           bodyContent.style.height = 'auto';
//           bodyContent.style.minHeight = '';
//         }
//         checkOverlap('.accordion__body-description', '.accordion__item-image', true);
//         checkOverflow('.accordion__body-content', '.accordion__item-image', true);
//       }
//     });
//   }
// }

// class AccordionItem {
//   constructor(el, accordion) {
//     this.el = el;
//     this.accordion = accordion;
//     this.elButton = this.el.querySelector(".accordion__item-button");
//     this.elPanel = this.el.querySelector(".accordion__item-panel");

//     this.elButton.addEventListener(
//       "click",
//       function () {
//         const accordionExpanded =
//           this.elButton.getAttribute("aria-expanded") === "true";
//           // const offset = 92;
//           // const y = this.el.getBoundingClientRect().top + window.scrollY - offset;
//           // window.scrollTo({ top: y, behavior: 'smooth' });


//         if (!accordionExpanded) {
//           this.accordion.closeOtherItems(this.el);

//           this.elButton.setAttribute("aria-expanded", true);
//           this.elPanel.style.height = this.elPanel.scrollHeight + "px";
//           this.elPanel.style.transition =
//             "height .1s ease-in-out, opacity .5s ease-in-out .2s, margin-top .25s ease-in-out";
//           this.elPanel.style.opacity = "1";
//           this.el.classList.add("expanded");

          
//           const bodyContent = this.el.querySelector('.accordion__body-content');
//           if (bodyContent) {
//             bodyContent.style.height = 'auto';
//             bodyContent.style.minHeight = '';
//           }
//         } else {
//           this.elButton.setAttribute("aria-expanded", false);
//           this.elPanel.style.transition =
//             "height .25s ease-in-out, opacity .25s ease-in-out .2s, margin-top .25s ease-in-out .1s";
//           this.elPanel.style.height = "0px";
//           this.elPanel.style.opacity = "0";
//           this.el.classList.remove("expanded");

//           const bodyContent = this.el.querySelector('.accordion__body-content');
//           if (bodyContent) {
//             bodyContent.style.height = 'auto';
//             bodyContent.style.minHeight = '';
//           }
//         }
//       }.bind(this),
//       false
//     );
//   }
// }



// const initAccordions = () => {
//   const accordions = document.querySelectorAll(".js-simple-accordion");

//   if (accordions) {
//     for (let accordion of accordions) {
//       new SimpleAccordionItems(accordion);
//     }
//   }
// };

// initAccordions();



class ItemsAccordion {
  constructor(el) {
    this.el = el;
    this.items = this.el.querySelectorAll(".accordion__item");
    for (let accordion of this.items) {
      new ItemsAccordionItem(accordion);
    }
    this.handleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.handleResize);
  }

  handleResize() {
    for (let accordionItem of this.items) {
      const item = accordionItem.querySelector(".accordion__item-panel");
      if (accordionItem.querySelector(".accordion__item-button").getAttribute("aria-expanded") === "true") {
        item.style.height = 'auto';
        item.style.height = item.scrollHeight + 'px';
      }
    }
  }
}

class ItemsAccordionItem {
  constructor(el) {
    this.el = el;
    this.elButton = this.el.querySelector(".accordion__item-button");
    this.elButtonIcon = this.el.querySelector(".accordion__item-button-icon");
    this.elButtonIconSvg = this.el.querySelector(".accordion__item-button-icon .delete");
    this.elPanel = this.el.querySelector(".accordion__item-panel");
    this.elLinks = this.el.querySelector(".accordion__item-panel a");


    this.elButton.addEventListener(
      "click",
      function (ev) {
        let accordionExpanded =
          this.elButton.getAttribute("aria-expanded") === "true";

        if (!accordionExpanded) {
          const offset = '80';
          const y = this.el.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: y, behavior: 'smooth' });

          this.elPanel.setAttribute("tabindex", 0);
          if(this.elLinks) {
            this.elLinks.setAttribute("tabindex", 0);
          }
          this.elPanel.style.pointerEvents = "all";
          this.elPanel.style.transition = "height .25s linear, opacity .5s linear .5s";
          this.elButton.setAttribute("aria-expanded", true);
          this.elPanel.style.height = this.elPanel.scrollHeight + "px";
          this.elPanel.style.opacity = "1";


          setTimeout(() => {
            if(this.elButtonIconSvg) {
              this.elButtonIconSvg.style.display = "none";
            }
            if(this.elButtonIcon) {
              this.elButtonIcon.style.animation = "";
            }
          }, 250);
        } else {
          this.elPanel.setAttribute("tabindex", -1);
          if(this.elLinks) {
            this.elLinks.setAttribute("tabindex", -1);
          }
          this.elPanel.style.pointerEvents = "none";
          this.elPanel.style.transition = "height .25s linear, opacity .2s linear";
          this.elPanel.style.opacity = "0";
          setTimeout(() => {
            this.elButton.setAttribute("aria-expanded", false);
            this.elPanel.style.height = "0";
          }, 200);
          
          setTimeout(() => {
            if(this.elButtonIcon) {
              this.elButtonIcon.style.animation = "";
            }
            if(this.elButtonIconSvg) {
              this.elButtonIconSvg.style.display = "block";
            }
          }, 450);
        }
      }.bind(this),
      false
    );
  }
}

const initAccordions = () => {
  const accordions = document.querySelectorAll(".js-simple-accordion");
  if (accordions) {
    for (let accordion of accordions) {
      new ItemsAccordion(accordion);
    }
  }
};

initAccordions();




